import { render, staticRenderFns } from "./main-slides.vue?vue&type=template&id=0408fd58&scoped=true&"
import script from "./main-slides.vue?vue&type=script&lang=js&"
export * from "./main-slides.vue?vue&type=script&lang=js&"
import style0 from "./main-slides.vue?vue&type=style&index=0&id=0408fd58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408fd58",
  null
  
)

export default component.exports